import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  name: "主页",
  class: "base"
}
const _hoisted_2 = {
  name: "组件",
  class: "base"
}
const _hoisted_3 = {
  name: "旧版",
  class: "base"
}
const _hoisted_4 = { style: {"display":"flex","align-items":"center","font-size":"0.8rem"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "这是 Border Card UI for Web （纯 html+css+js）版本的相关文档，此版本已停止更新并且也不会再有变更。 但是它依旧可以通过这儿使用！", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("iframe", { src: "docs/index.html" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Home = _resolveComponent("Home")!
  const _component_VueDoc = _resolveComponent("VueDoc")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ss_card = _resolveComponent("ss-card")!
  const _component_bc_tab = _resolveComponent("bc-tab")!

  return (_openBlock(), _createBlock(_component_bc_tab, { title: "Border Card UI" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Home)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_VueDoc)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ss_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_font_awesome_icon, {
                style: {"margin-right":"30px"},
                icon: "fa-solid fa-lightbulb"
              }),
              _hoisted_5
            ])
          ]),
          _: 1
        }),
        _hoisted_6
      ])
    ]),
    _: 1
  }))
}